import { Reset, Theme } from "@bluframe/blublocks"
import styled from "styled-components"

export const Wrapper = styled.div`
  align-items: center;
  background: ${({ theme }: { theme: Theme }) =>
    theme.palette.primary.contrast};
  column-gap: 20px;
  display: grid;
  grid-template-columns: auto 1fr;
  justify-items: end;

  & p {
    margin-bottom: 0;
  }
`

export const ModalWrapper = styled.div`
  display: grid;
  justify-items: center;
  padding: 0 20px;
  row-gap: 30px;
  width: 100%;
`

export const Columns = styled.div`
  align-items: start;
  column-gap: 86px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
`

export const Column = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 30px;

  & h4,
  h5 {
    text-align: center;
  }
`

export const TechSpecsAvailableUl = styled(Reset.Ul)`
  display: grid;
  row-gap: 10px;
`

export const TechSpecsAvailable = styled.div`
  align-items: center;
  display: grid;
  justify-items: start;
  row-gap: 10px;
  width: 100%;
`

export const ServiceNameAndAction = styled.div`
  align-items: center;
  column-gap: 20px;
  display: grid;
  grid-template-columns: auto 1fr;
  justify-items: start;
  width: 100%;

  & p {
    font-weight: 700;
    margin: 0;
  }
`
